import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "How quickly can your team arrive on-site?",
    a: "Our line is answered live 24/7. For active losses across Toronto and the GTA, we mobilize crews and contents specialists immediately after the call, typically reaching the property the same day, often within hours.",
  },
  {
    q: "Do you work directly with insurance adjusters?",
    a: "Yes. We routinely coordinate with adjusters and restoration contractors. Our inventory documentation and contents handling are built to be claims-ready, with photographs, categorization and salvageability assessment ready for the file.",
  },
  {
    q: "What happens to my belongings during the restoration?",
    a: "We carefully pack, label and transport your contents to our secure storage environments. You receive a documented inventory, and items remain under our chain of custody until pack-back.",
  },
  {
    q: "Do you handle high-value or fragile items?",
    a: "Yes. Our contents specialists are trained for art, antiques, electronics, important documents and other high-value items. Specialized packing materials and handling protocols are used where appropriate.",
  },
  {
    q: "Do you serve commercial properties and multi-unit buildings?",
    a: "Absolutely. We work with property managers, restoration contractors and ownership groups across multi-unit residential and commercial buildings throughout the GTA.",
  },
  {
    q: "What areas do you serve?",
    a: "Toronto, Mississauga, Brampton, Vaughan, Markham, Richmond Hill, Ajax, Pickering, Whitby, Oshawa, Burlington, Oakville and surrounding communities, backed by a wider North American network.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-section">
      {FAQS.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} className="accordion-item" data-testid={`faq-item-${i}`}>
            <button
              type="button"
              className="accordion-trigger"
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              data-testid={`faq-trigger-${i}`}
            >
              <span className="pr-6">{f.q}</span>
              <span className={`w-9 h-9 grid place-items-center border ${isOpen ? "bg-[hsl(var(--gaza-crimson))] border-[hsl(var(--gaza-crimson))] text-white" : "border-[hsl(var(--gaza-line))] text-[hsl(var(--gaza-teal))]"} transition`}>
                {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
              </span>
            </button>
            <div className={`accordion-content ${isOpen ? "open" : ""}`}>
              <p className="text-[hsl(var(--gaza-teal-mist))] leading-relaxed text-base max-w-3xl">{f.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
